/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import { FormHelperText, Hidden } from "@material-ui/core";
import { ScrollPanel } from "primereact/scrollpanel";
import Card from "@mui/material/Card";
import OutlinedInput from "@mui/material/OutlinedInput";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useSelector, useDispatch } from "react-redux";
import LoadingComponent from "../../lib/LoadingComponent";
import {
  getBizID,
  getBizName,
  getChangePassword,
  getLogo,
  setAuthen,
  setRoles,
  getStyle,
  setRequestCA,
  getRequestCA,
  setChangePassword,
} from "../../libs/todoSlice";
import {
  getTitleRedux,
  setTitleRedux,
  getFNameTHRedux,
  setFNameTHRedux,
  getLNameTHRedux,
  setLNameTHRedux,
  getFNameENRedux,
  setFNameENRedux,
  getLNameENRedux,
  setLNameENRedux,
  getLoadingRedux,
  setLoadingRedux,
  getCidRedux,
  setCidRedux,
  getAddressWorkRedux,
  setAddressWorkRedux,
  getTelRedux,
  setTelRedux,
  getPhoneRedux,
  setPhoneRedux,
  getEmailRedux,
  setEmailRedux,
  getPositionRedux,
  setPositionRedux,
  getSubOrganizationRedux,
  setSubOrganizationRedux,
  getOrganizationRedux,
  setOrganizationRedux,
  getTaxIDRedux,
  setTaxIDRedux,
  getORedux,
  setORedux,
  getTitleFeedbackRedux,
  setTitleFeedbackRedux,
  getFNameTHFeedbackRedux,
  setFNameTHFeedbackRedux,
  getLNameTHFeedbackRedux,
  setLNameTHFeedbackRedux,
  getFNameENFeedbackRedux,
  setFNameENFeedbackRedux,
  getLNameENFeedbackRedux,
  setLNameENFeedbackRedux,
  getCidFeedbackRedux,
  setCidFeedbackRedux,
  getAddressFeedbackRedux,
  setAddressFeedbackRedux,
  getTelFeedbackRedux,
  setTelFeedbackRedux,
  getPhoneFeedbackRedux,
  setPhoneFeedbackRedux,
  getEmailFeedbackRedux,
  setEmailFeedbackRedux,
  getCheckEditRedux,
  setCheckEditRedux,
  getCheckedRedux,
  setCheckedRedux,
  getOpenRedux,
  setOpenRedux,
} from "../../libs/verifyDetailSlice";
import fontColor from "../../lib/fontColor";
import Cookie from "../../lib/Cookie";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import { Checkbox } from "primereact/checkbox";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { logoutSession } from "../../lib/logoutRedirect";
import { Modal } from "antd";
import styled from "styled-components";
import { Modal as AntModal } from "antd";
import Swal from "sweetalert2";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { translateMessage } from "../../lib/errorKeyNote";

const CustomModal = styled(AntModal)`
  :where(.css-dev-only-do-not-override-1r287do).ant-modal .ant-modal-content {
    background-color: #fff8e1 !important;
  }
`;

function VerifyDetail() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const businessId = searchParams.get("business_id");
  const reduxBizID = useSelector(getBizID);
  const bizID = businessId === null ? reduxBizID : businessId;
  const changepass = useSelector(getChangePassword);
  const business_name = useSelector(getBizName);
  const logo = useSelector(getLogo);
  const style = useSelector(getStyle);
  const [cookie, setCookie, removeCookie] = useCookies([
    "access_token",
    "account",
    "new_user",
  ]);
  const titleRef = useRef();
  const fnameTHRef = useRef();
  const lnameTHRef = useRef();
  const fnameENRef = useRef();
  const lnameENRef = useRef();
  const cidRef = useRef();
  const addressRef = useRef();
  const telRef = useRef();
  const phoneRef = useRef();
  const emailRef = useRef();
  const requestCA = useSelector(getRequestCA);
  const [devicePixelRatio, setDevicePixelRatio] = useState();
  const [isFormValid, setIsFormValid] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const title = useSelector(getTitleRedux);
  const setTitle = (action) => {
    dispatch(
      setTitleRedux({
        title: action,
      })
    );
  };

  const fnameTH = useSelector(getFNameTHRedux);
  const setFNameTH = (action) => {
    dispatch(
      setFNameTHRedux({
        fnameTH: action,
      })
    );
  };

  const lnameTH = useSelector(getLNameTHRedux);
  const setLNameTH = (action) => {
    dispatch(
      setLNameTHRedux({
        lnameTH: action,
      })
    );
  };

  const fnameEN = useSelector(getFNameENRedux);
  const setFNameEN = (action) => {
    dispatch(
      setFNameENRedux({
        fnameEN: action,
      })
    );
  };

  const lnameEN = useSelector(getLNameENRedux);
  const setLNameEN = (action) => {
    dispatch(
      setLNameENRedux({
        lnameEN: action,
      })
    );
  };

  const loading = useSelector(getLoadingRedux);
  const setLoading = (action) => {
    dispatch(
      setLoadingRedux({
        loading: action,
      })
    );
  };

  const cid = useSelector(getCidRedux);
  const setCid = (action) => {
    dispatch(
      setCidRedux({
        cid: action,
      })
    );
  };

  const addressWork = useSelector(getAddressWorkRedux);
  const setAddressWork = (action) => {
    dispatch(
      setAddressWorkRedux({
        addressWork: action,
      })
    );
  };

  const tel = useSelector(getTelRedux);
  const setTel = (action) => {
    dispatch(
      setTelRedux({
        tel: action,
      })
    );
  };

  const phone = useSelector(getPhoneRedux);
  const setPhone = (action) => {
    dispatch(
      setPhoneRedux({
        phone: action,
      })
    );
  };

  const email = useSelector(getEmailRedux);
  const setEmail = (action) => {
    dispatch(
      setEmailRedux({
        email: action,
      })
    );
  };

  const position = useSelector(getPositionRedux);
  const setPosition = (action) => {
    dispatch(
      setPositionRedux({
        position: action,
      })
    );
  };

  const sub_organization = useSelector(getSubOrganizationRedux);
  const setSubOrganization = (action) => {
    dispatch(
      setSubOrganizationRedux({
        sub_organization: action,
      })
    );
  };

  const organization = useSelector(getOrganizationRedux);
  const setOrganization = (action) => {
    dispatch(
      setOrganizationRedux({
        organization: action,
      })
    );
  };

  const tax_id = useSelector(getTaxIDRedux);
  const setTaxID = (action) => {
    dispatch(
      setTaxIDRedux({
        tax_id: action,
      })
    );
  };

  const o = useSelector(getORedux);
  const setO = (action) => {
    dispatch(
      setORedux({
        o: action,
      })
    );
  };

  const titleFeedback = useSelector(getTitleFeedbackRedux);
  const setTitleFeedback = (action) => {
    dispatch(
      setTitleFeedbackRedux({
        titleFeedback: action,
      })
    );
  };

  const fnameTHFeedback = useSelector(getFNameTHFeedbackRedux);
  const setFNameTHFeedback = (action) => {
    dispatch(
      setFNameTHFeedbackRedux({
        fnameTHFeedback: action,
      })
    );
  };

  const lnameTHFeedback = useSelector(getLNameTHFeedbackRedux);
  const setLNameTHFeedback = (action) => {
    dispatch(
      setLNameTHFeedbackRedux({
        lnameTHFeedback: action,
      })
    );
  };

  const fnameENFeedback = useSelector(getFNameENFeedbackRedux);
  const setFNameENFeedback = (action) => {
    dispatch(
      setFNameENFeedbackRedux({
        fnameENFeedback: action,
      })
    );
  };

  const lnameENFeedback = useSelector(getLNameENFeedbackRedux);
  const setLNameENFeedback = (action) => {
    dispatch(
      setLNameENFeedbackRedux({
        lnameENFeedback: action,
      })
    );
  };

  const addressFeedback = useSelector(getAddressFeedbackRedux);
  const setAddressFeedback = (action) => {
    dispatch(
      setAddressFeedbackRedux({
        addressFeedback: action,
      })
    );
  };

  const cidFeedback = useSelector(getCidFeedbackRedux);
  const setCidFeedback = (action) => {
    dispatch(
      setCidFeedbackRedux({
        cidFeedback: action,
      })
    );
  };

  const telFeedback = useSelector(getTelFeedbackRedux);
  const setTelFeedback = (action) => {
    dispatch(
      setTelFeedbackRedux({
        telFeedback: action,
      })
    );
  };

  const phoneFeedback = useSelector(getPhoneFeedbackRedux);
  const setPhoneFeedback = (action) => {
    dispatch(
      setPhoneFeedbackRedux({
        phoneFeedback: action,
      })
    );
  };

  const emailFeedback = useSelector(getEmailFeedbackRedux);
  const setEmailFeedback = (action) => {
    dispatch(
      setEmailFeedbackRedux({
        emailFeedback: action,
      })
    );
  };

  const checkEdit = useSelector(getCheckEditRedux);
  const setCheckEdit = (action) => {
    dispatch(
      setCheckEditRedux({
        checkEdit: action,
      })
    );
  };

  const checked = useSelector(getCheckedRedux);
  const setChecked = (action) => {
    dispatch(
      setCheckedRedux({
        checked: action,
      })
    );
  };

  const open = useSelector(getOpenRedux);
  const setOpen = (action) => {
    dispatch(
      setOpenRedux({
        open: action,
      })
    );
  };

  const [modalDuplicateCID, setModalDuplicateCID] = useState(false);

  useEffect(() => {
    const handleResize = () => setDevicePixelRatio(window.devicePixelRatio);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getTaxID();
    setOrganization(business_name);
    getBusinessDetailCA();
    if (cookie.new_user) {
      dispatch(
        setRequestCA({
          requested_ca: cookie.new_user.requestCA,
        })
      );
      dispatch(
        setChangePassword({
          change_password: cookie.new_user.changed_password,
        })
      );
    }
  }, []);

  useEffect(() => {
    if (requestCA === false && changepass === true) {
      const target = `/${params.prefix}/manage-members`
      navigate(target);
    } else if (requestCA === false && changepass === false) {
      const target = `/${params.prefix}/login-user/change-password`
      navigate(target);
    }
  }, [requestCA, changepass]);

  useEffect(() => {
    if (!checkEdit && organization) {
      const runValidate = async () => {
        const isValid = await validateFieldsForSubmit();
        if (!isValid) setOpen(true);
      };
      runValidate();
    }
  }, [checkEdit]);

  useEffect(() => {
    const checkForm = () => {
      const hasAllRequired =
        title && title !== "" &&
        fnameTH && fnameTH.replaceAll(" ", "") !== "" &&
        lnameTH && lnameTH.replaceAll(" ", "") !== "" &&
        fnameEN && fnameEN.replaceAll(" ", "") !== "" &&
        lnameEN && lnameEN.replaceAll(" ", "") !== "" &&
        cid && cid !== "" &&
        addressWork && addressWork.replaceAll(" ", "") !== "" &&
        phone && phone !== "" &&
        email && email.replaceAll(" ", "") !== "";

      // เช็ค format phone
      const phoneValid = phone && phone[0] === "0" && phone.length >= 10;

      // เช็ค format tel (optional แต่ถ้ากรอกต้องถูก)
      const telValid = !tel || tel === "" || (tel[0] === "0" && tel.length >= 10);

      // เช็ค format cid
      let cidValid = false;
      if (cid) {
        if (cid.length === 13) {
          cidValid = iDCardNumberValidator(cid);
        } else {
          cidValid = /^(?=.*[A-Z])(?=.*\d).{7,}$/.test(cid);
        }
      }

      setIsFormValid(!!hasAllRequired && phoneValid && telValid && cidValid);
    };
    checkForm();
  }, [title, fnameTH, lnameTH, fnameEN, lnameEN, cid, addressWork, phone, tel, email]);

  const getTaxID = async () => {
    await axios({
      method: "GET",
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/business/taxid?biz_id=${bizID}`,
    }).then(
      ({ data, status }) => {
        setTaxID(data.data.tax_id);
      },
      ({ response }) => {
        const { status } = response;
        if (status === 401) {
          navigate(`/${params.prefix}`);
        }
      }
    );
  };

  const getBusinessDetailCA = async () => {
    await axios({
      method: "GET",
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ca/preview?business_id=${bizID}`,
    }).then(
      ({ data, status }) => {
        setTitle(data.data[0].accountTitleNameTH);
        setFNameTH(data.data[0].firstNameThai);
        setLNameTH(data.data[0].lastNameThai);
        setFNameEN(data.data[0].firstNameEng);
        setLNameEN(data.data[0].lastNameEng);
        setCid(data.data[0].idNumberPerSonal);
        setAddressWork(data.data[0].address);
        // setTel(data.data[0].mobile)
        setPhone(data.data[0].mobile);
        setEmail(data.data[0].email);
        setPosition(data.data[0].t);
        setSubOrganization(data.data[0].ou);
        setO(data.data[0].o);
      },
      ({ response }) => {
        const { status } = response;
        if (status === 401) {
          navigate(`/${params.prefix}`);
        }
      }
    );
  };

  const confirm = async () => {
    const title_th_list = ["นาย", "นาง", "นางสาว"];
    const title_en_list = ["Mr", "Mrs", "Miss"];
    const idx = title_th_list.indexOf(title);
    const title_en = idx !== -1 ? title_en_list[idx] : "";
    setLoading(true);
    try {
      await axios({
        method: "POST",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ca/request`,
        data: {
          first_name_th: fnameTH,
          last_name_thai: lnameTH,
          first_name_eng: fnameEN,
          last_name_eng: lnameEN,
          account_title_eng: title_en,
          account_title_th: title,
          business_id: bizID,
          biz_id: bizID,
          id_card_num: cid,
          ou: sub_organization,
          t: position,
          o: o,
          mobile: phone,
          email: email,
          address: addressWork,
        },
      });
      // สำเร็จ -> ไปต่อ step confirm สุดท้าย (loading จะถูกจัดการต่อใน lastConfirm)
      await lastConfirm();
    } catch (error) {
      const { response } = error;
      if (response) {
        const { status } = response;
        if (status === 401) {
          navigate(`/${params.prefix}`);
        } else if (status === 404) {
          if (!changepass) {
            navigate(`/${params.prefix}/login-user/change-password`);
          } else {
            navigate(`/${params.prefix}/manage-members`);
          }
        } else {
          showBackendError(response);
        }
      } else {
        console.log("Unexpected error:", error);
        Swal.fire({
          title: "ดำเนินการไม่สำเร็จ",
          icon: "error",
          text: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง",
        });
      }
      setLoading(false);
    }
  };

  const lastConfirm = async () => {
    try {
      await axios({
        method: "POST",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ca/confirm`,
        data: { business_id: bizID },
      });
      clearRequestCAAndNavigate();
    } catch (error) {
      const { response } = error;
      const status = response?.status;
      if (status === 401) {
        navigate(`/${params.prefix}`);
      } else {
        Swal.fire({
          title: "ดำเนินการไม่สำเร็จ",
          icon: "error",
        });
      }
    } finally {
      setLoading(false); // ปิด loading ไม่ว่าจะจบทาง success หรือ error
    }
  };

  const clearRequestCAAndNavigate = () => {
    setCookie("new_user", { ...cookie.new_user, requestCA: false }, {
      path: "/",
      expires: new Date(Date.now() + 3600000),
    });
    dispatch(setRequestCA({ requested_ca: false }));

    if (!changepass || cookie.new_user?.changed_password === false) {
      navigate(`/${params.prefix}/login-user/change-password`);
    } else {
      navigate(`/${params.prefix}/manage-members`);
    }
  };

  const logout = async () => {
    await logoutSession({
      removeCookie,
      dispatch,
      oauth: cookie.oauth,
      prefix: params.prefix,
    })
  };

  const iDCardNumberValidator = (number) => {
    let valid = true;
    const id = number.replaceAll("-", "");
    if (id.length != 13) {
      valid = false;
    }
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) {
      valid = false;
    } else {
      valid = true;
    }
    return valid;
  };

  const duplicateCID = async (number) => {
    try {
      await axios({
        method: "GET",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/user/check-id-card?id_card_num=${number}`,
      });
      return true;
    } catch {
      return false;
    }
  };

  const validate = async (items) => {
    if (items.name == "demo-simple-select") {
      if (title == "" || title == null) {
        setTitleFeedback("กรุณาเลือกคำนำหน้า");
        return false;
      } else {
        setTitleFeedback("");
        return true;
      }
    } else if (items.id == "fnameTH") {
      if (fnameTH != null) {
        if (fnameTH.replaceAll(" ", "") == "") {
          setFNameTHFeedback("กรุณากรอกชื่อภาษาไทย");
          return false;
        } else {
          setFNameTHFeedback("");
          return true;
        }
      } else {
        setFNameTHFeedback("กรุณากรอกชื่อภาษาไทย");
        return false;
      }
    } else if (items.id == "lnameTH") {
      if (lnameTH != null) {
        if (lnameTH.replaceAll(" ", "") == "") {
          setLNameTHFeedback("กรุณากรอกนามสกุลภาษาไทย");
          return false;
        } else {
          setLNameTHFeedback("");
          return true;
        }
      } else {
        setLNameTHFeedback("กรุณากรอกนามสกุลภาษาไทย");
        return false;
      }
    } else if (items.id == "fnameEN") {
      if (fnameEN != null) {
        if (fnameEN.replaceAll(" ", "") == "") {
          setFNameENFeedback("กรุณากรอกชื่อภาษาอังกฤษ");
          return false;
        } else {
          setFNameENFeedback("");
          return true;
        }
      } else {
        setFNameENFeedback("กรุณากรอกชื่อภาษาอังกฤษ");
        return false;
      }
    } else if (items.id == "lnameEN") {
      if (lnameEN != null) {
        if (lnameEN.replaceAll(" ", "") == "") {
          setLNameENFeedback("กรุณากรอกนามสกุลภาษาอังกฤษ");
          return false;
        } else {
          setLNameENFeedback("");
          return true;
        }
      } else {
        setLNameENFeedback("กรุณากรอกนามสกุลภาษาอังกฤษ");
        return false;
      }
    } else if (items.id == "cid") {
      if (cid == "" || cid == null) {
        setCidFeedback("กรุณากรอกเลขบัตรประชาชน หรือเลขหนังสือเดินทาง ");
        return false;
      } else if (cid.length != 13) {
        const regexPassport = /^(?=.*[A-Z])(?=.*\d).{7,}$/;
        if (regexPassport.test(cid) === true) {
          regexPassport.test(cid);
          setCidFeedback("");
          return true;
        } else {
          setCidFeedback(
            "เลขที่หนังสือเดินทางต้องมีตัวอักษรภาษาอังกฤษพิมพ์ใหญ่ และตัวเลข 1 ตัวอักษรเป็นอย่างน้อย และมีความยาวมากกว่า 6 ตัวอักษร"
          );
          return false;
        }
      } else if (!iDCardNumberValidator(cid)) {
        setCidFeedback("เลขบัตรประชาชนไม่ถูกต้อง");
        return false;
      } else if (!(await duplicateCID(cid))) {
        setCidFeedback("เลขบัตรประชาชนมีผู้ใช้งานแล้ว");
        setModalDuplicateCID(true);
        return false;
      } else {
        setCidFeedback("");
        return true;
      }
    } else if (items.id == "addressWork") {
      if (addressWork != null) {
        if (addressWork.replaceAll(" ", "") == "") {
          setAddressFeedback("กรุณากรอกที่อยู่หน่วยงานที่สังกัด");
          return false;
        } else {
          setAddressFeedback("");
          return true;
        }
      } else {
        setAddressFeedback("กรุณากรอกที่อยู่หน่วยงานที่สังกัด");
        return false;
      }
    } else if (items.id == "tel") {
      if (tel == "" || tel == null) {
        setTelFeedback("");
        return true;
      } else if (tel[0] != "0") {
        setTelFeedback("เบอร์โทรศัพท์ต้องขึ้นต้นด้วย 0");
        return false;
      } else if (tel.length < 10) {
        setTelFeedback("เบอร์โทรศัพท์ต้องมี 10 หลัก");
        return false;
      } else {
        setTelFeedback("");
        return true;
      }
    } else if (items.id == "phone") {
      if (phone == "" || phone == null) {
        setPhoneFeedback("กรุณากรอกเบอร์โทรศัพท์มือถือ");
        return false;
      } else if (phone[0] != "0") {
        setPhoneFeedback("เบอร์โทรศัพท์มือถือต้องขึ้นต้นด้วย 0");
        return false;
      } else if (phone.length < 10) {
        setPhoneFeedback("เบอร์โทรศัพท์มือถือต้องมี 10 หลัก");
        return false;
      } else {
        setPhoneFeedback("");
        return true;
      }
    } else if (items.id == "email") {
      if (email != null) {
        if (email.replaceAll(" ", "") == "") {
          setEmailFeedback("กรุณากรอกอีเมล");
          return false;
        } else {
          setEmailFeedback("");
          return true;
        }
      } else {
        setEmailFeedback("กรุณากรอกอีเมล");
        return false;
      }
    }
  };

  const getForgetPassword = async () => {
    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/login-user/forgot-password?prefix=${params.prefix}`,
      });

      const url = response.data?.data?.url;
      if (url) {
        window.location.href = url;
      } else {
        console.error(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const addBizLogin = async () => {
    setLoading(true);
    await axios({
      method: "POST",
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/add-to-role`,
      data: {
        biz_id: bizID,
        id_card_num: cid,
      },
    }).then(
      ({ data, status }) => {
        logout();
        setLoading(false);
      },
      ({ response }) => {
        if (response.data.message === "Account already have this Role.") {
          logout();
        } else {
          Swal.fire({
            title: "ดำเนินการไม่สำเร็จ",
            icon: "error",
          });
        }
        setLoading(false);
      }
    );
  };

  const addBizForget = async () => {
    setLoading(true);
    await axios({
      method: "POST",
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/add-to-role`,
      data: {
        biz_id: bizID,
        id_card_num: cid,
      },
    }).then(
      ({ data, status }) => {
        getForgetPassword();
        setLoading(false);
      },
      ({ response }) => {
        if (response.data.message === "Account already have this Role.") {
          getForgetPassword();
        } else {
          Swal.fire({
            title: "ดำเนินการไม่สำเร็จ",
            icon: "error",
          });
        }
        setLoading(false);
      }
    );
  };

  // step 3: check-and-update (auto approve)
  const checkCaAutoAndUpdateForAutoApproved = async () => {
    await axios({
      method: "GET",
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ca/auto/check-and-update`,
    });
    clearRequestCAAndNavigate();
  };

  // step 2: confirm (auto approve)
  const lastConfirmCAForAutoApproved = async () => {
    await axios({
      method: "POST",
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ca/auto/confirm`,
      data: { business_id: bizID },
    });
    await checkCaAutoAndUpdateForAutoApproved();
  };

  // step 1: request (auto approve) — จุดเดียวที่คุม loading และ error ทั้งเชน
  const confirmCAForAutoApproved = async () => {
    try {
      setLoading(true);

      const title_th_list = ["นาย", "นาง", "นางสาว"];
      const title_en_list = ["Mr", "Mrs", "Miss"];
      const idx = title_th_list.indexOf(title);
      const title_en = idx !== -1 ? title_en_list[idx] : "";

      await axios({
        method: "POST",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ca/auto/request`,
        data: {
          first_name_th: fnameTH,
          last_name_thai: lnameTH,
          first_name_eng: fnameEN,
          last_name_eng: lnameEN,
          account_title_eng: title_en,
          account_title_th: title,
          business_id: bizID,
          biz_id: bizID,
          id_card_num: cid,
          ou: sub_organization,
          t: position,
          o: o,
          mobile: phone,
          email: email,
          address: addressWork,
        },
      });

      // สำเร็จทั้งเชน (request -> confirm -> check-and-update -> navigate)
      await lastConfirmCAForAutoApproved();
    } catch (error) {
      const { response } = error;
      if (response) {
        const { status } = response;
        if (status === 401) {
          navigate(`/${params.prefix}`);
        } else if (status === 404) {
          if (!changepass) {
            navigate(`/${params.prefix}/login-user/change-password`);
          } else {
            navigate(`/${params.prefix}/manage-members`);
          }
        } else {
          showBackendError(response);
        }
      } else {
        console.log("Unexpected error:", error);
        Swal.fire({
          title: "ดำเนินการไม่สำเร็จ",
          icon: "error",
          text: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const validateFieldsForSubmit = async () => {
    const results = await Promise.all([
      validate(titleRef.current?.children[1]),
      validate(fnameTHRef.current?.children[0]?.children[0]),
      validate(lnameTHRef.current?.children[0]?.children[0]),
      validate(fnameENRef.current?.children[0]?.children[0]),
      validate(lnameENRef.current?.children[0]?.children[0]),
      validate(cidRef.current?.children[0]?.children[0]),
      validate(addressRef.current?.children[0]?.children[0]),
      validate(telRef.current?.children[0]?.children[0]),
      validate(phoneRef.current?.children[0]?.children[0]),
      validate(emailRef.current?.children[0]?.children[0]),
    ]);

    return results.every(Boolean);
  };

  const handleSubmitForReqCa = async () => {
    const isValid = await validateFieldsForSubmit();
    if (!isValid) {
      setOpen(true);
      return;
    }
    let notAutoApprovedPrefixes = [];
    try {
      const keyPrefix =
      process.env.REACT_APP_NOT_AUTO_APPROVED_CA_PREFIX ?? '["pmuc","pmub"]';
      notAutoApprovedPrefixes = JSON.parse(keyPrefix);
      const isAutoApprove = notAutoApprovedPrefixes.includes(params.prefix);
      if (isAutoApprove) {
        await confirm();
      } else {
        await confirmCAForAutoApproved();
      }
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  // map field -> setter สำหรับ field-level feedback (ใช้เมื่อ backend ส่ง error เป็น object รายฟิลด์)
  const fieldFeedbackMap = {
    title_th: setTitleFeedback,
    first_name_th: setFNameTHFeedback,
    last_name_thai: setLNameTHFeedback,
    first_name_eng: setFNameENFeedback,
    last_name_eng: setLNameENFeedback,
    id_card_num: setCidFeedback,
    address: setAddressFeedback,
    tel: setTelFeedback,
    mobile: setPhoneFeedback,
    email: setEmailFeedback,
  };

  const showBackendError = (response, fallbackTitle = "ดำเนินการไม่สำเร็จ") => {
    const rawMessage = response?.data?.message;
    const statusText = response?.statusText;

    // ไม่มี message จาก backend เลย -> fallback เป็น statusText เดิม
    if (!rawMessage) {
      Swal.fire({ title: fallbackTitle, icon: "error", text: statusText });
      return;
    }

    const translated = translateMessage(rawMessage);

    if (translated && typeof translated === "object" && !Array.isArray(translated)) {
      // message เป็น object รายฟิลด์ เช่น { email: ["..."], cid: ["..."] }
      const unmatchedMessages = [];
      let matchedFieldCount = 0;

      Object.entries(translated).forEach(([field, errors]) => {
        const errorText = Array.isArray(errors) ? errors[0] : errors;
        const setter = fieldFeedbackMap[field];
        if (setter) {
          setter(errorText);
          matchedFieldCount += 1;
        } else {
          unmatchedMessages.push(errorText);
        }
      });

      if (unmatchedMessages.length > 0) {
        Swal.fire({
          title: "ข้อมูลไม่ถูกต้อง",
          icon: "warning",
          text: unmatchedMessages.join(", "),
        });
      } else if (matchedFieldCount > 0) {
        Swal.fire({
          title: "ข้อมูลไม่ถูกต้อง",
          icon: "warning",
          text: "กรุณาตรวจสอบข้อมูลในช่องที่มีข้อความสีแดงกำกับอยู่ แล้วลองอีกครั้ง",
        });
      }
    } else if (Array.isArray(translated)) {
      // message เป็น array ของ string
      Swal.fire({
        title: "ข้อมูลไม่ถูกต้อง",
        icon: "warning",
        text: translated.join(", ") || "กรุณาตรวจสอบข้อมูลที่กรอกอีกครั้ง",
      });
    } else {
      // message เป็น string ธรรมดา
      Swal.fire({
        title: fallbackTitle,
        icon: "error",
        text: translated || statusText,
      });
    }
  };

  return (
    <div
      style={{
        background: "#F8F9FA",
        height: "100vh",
        overflow: "auto",
      }}
    >
      <div style={{ padding: "30px 80px 0 80px", marginBottom: "50px" }}>
        <img
          src={`data:image/png;base64, ${logo}`}
          alt=""
          onError={({ target }) => {
            target.src = "/one-platform.png";
          }}
          style={{
            maxHeight: "60px",
            maxWidth: "60px",
          }}
        />
        <span
          style={{
            fontWeight: "600",
            color: "#000",
            padding: "10px",
          }}
        >
          {business_name}
        </span>
        <span
          style={{
            float: "right",
          }}
        >
          <Button
            onClick={() => {
              logout();
            }}
            sx={{
              // color: fontColor('#053075'),
              justifyContent: "center",
              alignItems: "center",
              padding: "9px 15px",
              gap: "10px",
              width: "120px",
              height: "36px",
              // background: '#053075',
              borderRadius: "6px",
              float: "right",
              color: fontColor(style.secondary_color),
              background: style.secondary_color,
            }}
          >
            ออกจากระบบ
          </Button>
        </span>
      </div>
      <Hidden xsDown>
        <div style={{ display: "flex", justifyContent: "right" }}>
          <img
            src="/img_create_path.png"
            style={{
              position: "fixed",
              width: "670.75px",
              height: "650.54px",
              top: "110px",
            }}
            alt=""
          />
        </div>
      </Hidden>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "10px 40px",
        }}
      >
        <div style={{ zIndex: "1" }}>
          <Card
            style={{
              width: "80vw",
              height: "100%",
              maxHeight: devicePixelRatio == "1" ? "820px" : "600px",
              background: "rgba(0, 0, 0, 0.2)",
              borderRadius: "32px",
              padding: "15px 40px",
              color: "#053075",
              overflow: "auto",
            }}
          >
            <span
              style={{
                display: "flex",
                justifyContent: "center",
                fontWeight: "700",
                fontSize: "22px",
                lineHeight: "50px",
                letterSpacing: "0.02em",
                paddingBottom: "10px",
              }}
            >
              ตรวจสอบข้อมูลเพื่อยืนยันความถูกต้อง
            </span>
            <div className="card-croll-panel">
              <ScrollPanel
                style={{
                  width: "100%",
                  height: devicePixelRatio == "1" ? "600px" : "400px",
                  backgroundColor: "#ffffff33",
                  borderRadius: "10px",
                  padding: "20px",
                  paddingBottom: "0px",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "21px",
                    letterSpacing: "0.02em",
                  }}
                >
                  <Row style={{ padding: "5px 10px" }}>
                    <Col lg={2}>
                      <FormControl fullWidth error={titleFeedback.length != 0}>
                        <label htmlFor="title" style={{ color: "#000" }}>
                          คำนำหน้า
                        </label>
                        <Select
                          ref={titleRef}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="demo-simple-select"
                          value={title}
                          onChange={({ target }) => {
                            validate(target);
                            setTitle(target.value);
                          }}
                          sx={{
                            width: "100%",
                            background: checkEdit ? "#e0e0e0" : "white",
                            margin: "10px 0",
                            fontSize: "18px",
                          }}
                          // readOnly={checkEdit}
                          disabled={checkEdit}
                          size="small"
                          onBlur={(e) => {
                            validate(e.target);
                          }}
                        >
                          <MenuItem value={"นาย"}>นาย</MenuItem>
                          <MenuItem value={"นาง"}>นาง</MenuItem>
                          <MenuItem value={"นางสาว"}>นางสาว</MenuItem>
                        </Select>
                        <FormHelperText
                          style={{ color: "#f44336", paddingLeft: "12px" }}
                        >
                          {titleFeedback}
                        </FormHelperText>
                      </FormControl>
                    </Col>
                    <Col lg={5}>
                      <div style={{ display: "flex" }}>
                        <label htmlFor="fnameTH" style={{ color: "#000" }}>
                          ชื่อ (ภาษาไทย)
                        </label>
                      </div>
                      <TextField
                        ref={fnameTHRef}
                        id="fnameTH"
                        value={fnameTH}
                        placeholder="ชื่อ (ภาษาไทย)"
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        inputProps={{
                          sx: {
                            background: checkEdit ? "#e0e0e0" : "white",
                            borderRadius: "6px",
                          },
                          maxLength: 100,
                          tabIndex: "0",
                          // readOnly: checkEdit
                        }}
                        onChange={(e) => {
                          const { value } = e.target;
                          const onlyThai = value.replace(/[^ก-๙.\- ]/g, "");
                          setFNameTH(onlyThai);
                        }}
                        onKeyUp={(e) => {
                          validate(e.target);
                        }}
                        onBlur={(e) => {
                          validate(e.target);
                        }}
                        fullWidth
                        error={fnameTHFeedback.length != 0}
                        helperText={fnameTHFeedback}
                        disabled={checkEdit}
                      />
                    </Col>
                    <Col lg={5}>
                      <div style={{ display: "flex" }}>
                        <label htmlFor="lnameTH" style={{ color: "#000" }}>
                          นามสกุล (ภาษาไทย)
                        </label>
                      </div>
                      <TextField
                        ref={lnameTHRef}
                        id="lnameTH"
                        value={lnameTH}
                        placeholder="นามสกุล (ภาษาไทย)"
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        inputProps={{
                          sx: {
                            background: checkEdit ? "#e0e0e0" : "white",
                            borderRadius: "6px",
                          },
                          maxLength: 100,
                          tabIndex: "0",
                          // readOnly:checkEdit
                        }}
                        onChange={(e) => {
                          const { value } = e.target;
                          const onlyThai = value.replace(/[^ก-๙.\- ]/g, "");
                          setLNameTH(onlyThai);
                        }}
                        onKeyUp={(e) => {
                          validate(e.target);
                        }}
                        onBlur={(e) => {
                          validate(e.target);
                        }}
                        error={lnameTHFeedback.length != 0}
                        helperText={lnameTHFeedback}
                        fullWidth
                        disabled={checkEdit}
                      />
                    </Col>
                  </Row>
                  <Row style={{ padding: "5px 10px" }}>
                    <Col lg={6}>
                      <div style={{ display: "flex" }}>
                        <label htmlFor="fnameEN" style={{ color: "#000" }}>
                          ชื่อ (ภาษาอังกฤษ)
                        </label>
                      </div>
                      <TextField
                        ref={fnameENRef}
                        id="fnameEN"
                        value={fnameEN}
                        placeholder="ชื่อ (ภาษาอังกฤษ)"
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        onChange={(e) => {
                          const { value } = e.target;
                          const onlyEng = value.replace(/[^A-Za-z ]/g, "");
                          setFNameEN(onlyEng);
                        }}
                        onKeyUp={(e) => {
                          validate(e.target);
                        }}
                        onBlur={(e) => {
                          validate(e.target);
                        }}
                        error={fnameENFeedback.length != 0}
                        helperText={fnameENFeedback}
                        inputProps={{
                          sx: {
                            background: checkEdit ? "#e0e0e0" : "white",
                            borderRadius: "6px",
                          },
                          maxLength: 100,
                          tabIndex: "0",
                          // readOnly:checkEdit
                        }}
                        fullWidth
                        disabled={checkEdit}
                      />
                    </Col>
                    <Col lg={6}>
                      <div style={{ display: "flex" }}>
                        <label htmlFor="lnameEN" style={{ color: "#000" }}>
                          นามสกุล (ภาษาอังกฤษ)
                        </label>
                      </div>
                      <TextField
                        ref={lnameENRef}
                        id="lnameEN"
                        value={lnameEN}
                        placeholder="นามสกุล (ภาษาอังกฤษ)"
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        onChange={(e) => {
                          const { value } = e.target;
                          const onlyEng = value.replace(/[^A-Za-z]/g, "");
                          setLNameEN(onlyEng);
                        }}
                        onKeyUp={(e) => {
                          validate(e.target);
                        }}
                        onBlur={(e) => {
                          validate(e.target);
                        }}
                        error={lnameENFeedback.length != 0}
                        helperText={lnameENFeedback}
                        inputProps={{
                          sx: {
                            background: checkEdit ? "#e0e0e0" : "white",
                            borderRadius: "6px",
                          },
                          maxLength: 100,
                          tabIndex: "0",
                          // readOnly:checkEdit
                        }}
                        fullWidth
                        disabled={checkEdit}
                      />
                    </Col>
                  </Row>
                  <Row style={{ padding: "5px 10px" }}>
                    <Col lg={12}>
                      <div style={{ display: "flex" }}>
                        <label htmlFor="cid" style={{ color: "#000" }}>
                          เลขประจำตัวประชาชน (Identification Card) /
                          เลขที่หนังสือเดินทาง (Passport No.)
                        </label>
                      </div>
                      <TextField
                        ref={cidRef}
                        id="cid"
                        value={cid}
                        placeholder="เลขประจำตัวประชาชน (Identification Card) / เลขที่หนังสือเดินทาง (Passport No.)"
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        onChange={(e) => {
                          const { value } = e.target;
                          const NumAndEng = value.replace(/[^A-Z0-9]/g, "");
                          setCid(NumAndEng);
                        }}
                        onKeyUp={(e) => {
                          validate(e.target);
                        }}
                        onBlur={(e) => {
                          validate(e.target);
                        }}
                        error={cidFeedback.length != 0}
                        helperText={cidFeedback}
                        inputProps={{
                          sx: {
                            background: checkEdit ? "#e0e0e0" : "white",
                            borderRadius: "6px",
                          },
                          maxLength: 20,
                          tabIndex: "0",
                          // readOnly:checkEdit
                        }}
                        fullWidth
                        disabled={checkEdit}
                      />
                    </Col>
                  </Row>
                  <Row style={{ padding: "5px 10px" }}>
                    <Col>
                      <div style={{ display: "flex" }}>
                        <label htmlFor="addressWork" style={{ color: "#000" }}>
                          ที่อยู่หน่วยงานที่สังกัด
                        </label>
                      </div>
                      <TextField
                        ref={addressRef}
                        id="addressWork"
                        value={addressWork}
                        placeholder="ที่อยู่หน่วยงานที่สังกัด"
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        onChange={({ target }) => {
                          setAddressWork(target.value);
                        }}
                        inputProps={{
                          sx: {
                            background: checkEdit ? "#e0e0e0" : "white",
                            borderRadius: "6px",
                          },
                          maxLength: 100,
                          tabIndex: "0",
                        }}
                        fullWidth
                        disabled={checkEdit}
                        error={addressFeedback.length != 0}
                        helperText={addressFeedback}
                        onKeyUp={(e) => {
                          validate(e.target);
                        }}
                        onBlur={(e) => {
                          validate(e.target);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row style={{ padding: "5px 10px" }}>
                    <Col lg={4}>
                      <div style={{ display: "flex" }}>
                        <label htmlFor="tel" style={{ color: "#000" }}>
                          โทรศัพท์ (ถ้ามี)
                        </label>
                      </div>
                      <TextField
                        ref={telRef}
                        id="tel"
                        value={tel}
                        placeholder="โทรศัพท์ (ถ้ามี) *ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค"
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        onChange={(e) => {
                          const { value } = e.target;
                          const onlyNums = value.replace(/[^0-9]/g, "");
                          setTel(onlyNums);
                        }}
                        onKeyUp={(e) => {
                          validate(e.target);
                        }}
                        onBlur={(e) => {
                          validate(e.target);
                        }}
                        error={telFeedback.length != 0}
                        helperText={telFeedback}
                        inputProps={{
                          sx: {
                            background: checkEdit ? "#e0e0e0" : "white",
                            borderRadius: "6px",
                          },
                          maxLength: 10,
                          tabIndex: "0",
                          // readOnly:checkEdit
                        }}
                        fullWidth
                        disabled={checkEdit}
                      />
                    </Col>
                    <Col lg={4}>
                      <div style={{ display: "flex" }}>
                        <label htmlFor="phone" style={{ color: "#000" }}>
                          โทรศัพท์มือถือ
                        </label>
                      </div>
                      <TextField
                        ref={phoneRef}
                        id="phone"
                        value={phone}
                        placeholder="โทรศัพท์มือถือ (ถ้ามี) *ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค"
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        onChange={(e) => {
                          const { value } = e.target;
                          const onlyNums = value.replace(/[^0-9]/g, "");
                          setPhone(onlyNums);
                        }}
                        onKeyUp={(e) => {
                          validate(e.target);
                        }}
                        onBlur={(e) => {
                          validate(e.target);
                        }}
                        error={phoneFeedback.length != 0}
                        helperText={phoneFeedback}
                        inputProps={{
                          sx: {
                            background: checkEdit ? "#e0e0e0" : "white",
                            borderRadius: "6px",
                          },
                          maxLength: 10,
                          tabIndex: "0",
                          // readOnly:checkEdit
                        }}
                        fullWidth
                        disabled={checkEdit}
                      />
                    </Col>
                    <Col lg={4}>
                      <div style={{ display: "flex" }}>
                        <label htmlFor="email" style={{ color: "#000" }}>
                          อีเมล (อีเมลเจ้าของใบรับรอง)
                        </label>
                      </div>
                      <TextField
                        ref={emailRef}
                        id="email"
                        value={email}
                        placeholder="อีเมล (อีเมลเจ้าของใบรับรอง)"
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        // onChange={({target}) => {
                        //     setEmail(target.value);
                        // }}
                        // onKeyUp={(e) => {
                        //     validate(e.target)
                        // }}
                        // onBlur={(e) => {
                        //     validate(e.target)
                        // }}
                        error={emailFeedback.length != 0}
                        helperText={emailFeedback}
                        inputProps={{
                          sx: {
                            background: checkEdit ? "#e0e0e0" : "white",
                            borderRadius: "6px",
                          },
                          maxLength: 100,
                          tabIndex: "0",
                          // readOnly:checkEdit
                        }}
                        fullWidth
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row style={{ padding: "5px 10px" }}>
                    <Col lg={6}>
                      <div style={{ display: "flex" }}>
                        <label htmlFor="position" style={{ color: "#000" }}>
                          ตำแหน่งของเจ้าของใบรับรอง{" "}
                        </label>
                      </div>
                      <TextField
                        id="position"
                        value={position}
                        placeholder="ตำแหน่งของเจ้าของใบรับรอง"
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        onChange={({ target }) => {
                          setPosition(target.value);
                        }}
                        inputProps={{
                          sx: {
                            background: "#e0e0e0",
                            borderRadius: "6px",
                          },
                          maxLength: 100,
                          tabIndex: "0",
                        }}
                        fullWidth
                        disabled
                      />
                    </Col>
                    <Col lg={6}>
                      <div style={{ display: "flex" }}>
                        <label
                          htmlFor="sub_organization"
                          style={{ color: "#000" }}
                        >
                          ชื่อของหน่วยงานย่อยในองค์กรที่เจ้าของใบรับรองสังกัด
                        </label>
                      </div>
                      <TextField
                        id="sub_organization"
                        value={sub_organization}
                        placeholder="ชื่อของหน่วยงานย่อยในองค์กรที่เจ้าของใบรับรองสังกัด "
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        onChange={({ target }) => {
                          setSubOrganization(target.value);
                        }}
                        inputProps={{
                          sx: {
                            background: "#e0e0e0",
                            borderRadius: "6px",
                          },
                          maxLength: 100,
                          tabIndex: "0",
                        }}
                        fullWidth
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row style={{ padding: "5px 10px 0px 10px" }}>
                    <Col lg={6}>
                      <div style={{ display: "flex" }}>
                        <label htmlFor="organization" style={{ color: "#000" }}>
                          ชื่อองค์กรที่เจ้าของใบรับรองสังกัด
                        </label>
                      </div>
                      <TextField
                        id="organization"
                        value={organization}
                        placeholder="ชื่อองค์กรที่เจ้าของใบรับรองสังกัด"
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        onChange={({ target }) => {
                          setOrganization(target.value);
                        }}
                        inputProps={{
                          sx: {
                            background: "#e0e0e0",
                            borderRadius: "6px",
                          },
                          maxLength: 100,
                          tabIndex: "0",
                        }}
                        fullWidth
                        disabled
                      />
                    </Col>
                    <Col lg={6}>
                      <div style={{ display: "flex" }}>
                        <label htmlFor="tax_id" style={{ color: "#000" }}>
                          เลขประจำตัวผู้เสียภาษีอากรของนิติบุคคล
                        </label>
                      </div>
                      <TextField
                        id="tax_id"
                        value={tax_id}
                        placeholder="เลขประจำตัวผู้เสียภาษีอากรของนิติบุคคล"
                        size="small"
                        sx={{
                          margin: "10px 0",
                          fontSize: "18px",
                        }}
                        InputProps={<OutlinedInput />}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "14px",
                          },
                        }}
                        onChange={({ target }) => {
                          setTaxID(target.value);
                        }}
                        inputProps={{
                          sx: {
                            background: "#e0e0e0",
                            borderRadius: "6px",
                          },
                          maxLength: 100,
                          tabIndex: "0",
                        }}
                        fullWidth
                        disabled
                      />
                    </Col>
                  </Row>
                </span>
              </ScrollPanel>
            </div>
            <div style={{ marginTop: "20px" }}>
              <Checkbox
                onChange={
                  (e) => {
                    setChecked(e.checked);
                    if (e.checked && !isFormValid) {
                      setOpen(true);
                    }
                  }
                }
                checked={checked}
                style={{ marginRight: "10px" }}
              />
              <span style={{ fontSize: "14px", marginRight: "5px" }}>
                ตรวจสอบความถูกต้องของข้อมูลเรียบร้อย
              </span>
              <span
                style={{ fontSize: "14px", marginRight: "5px", color: "red" }}
              >
                {" "}
                (เมื่อยืนยันข้อมูลแล้ว จะไม่สามารถแก้ไขข้อมูลได้
                และข้อมูลจะถูกนำไปสร้างใบรับรองอิเล็กทรอนิกส์){" "}
              </span>
            </div>
            <div
              style={{
                marginTop: "25px",
                marginBottom: "20px",
                display: "flex",
                gap: "12px",
                justifyContent: "center",
                padding: "0 4px",
              }}
            >
              <Button
                variant="outlined"
                style={{
                  flex: 1,
                  maxWidth: "200px",
                  minHeight: "44px",
                  padding: "10px 12px",
                  color: "#053075",
                  borderRadius: "6px",
                  border: "1px solid #053075",
                  whiteSpace: "normal",
                  lineHeight: 1.4,
                  wordBreak: "keep-all",
                }}
                onClick={() => setCheckEdit(false)}
              >
                แก้ไข/เพิ่มเติมข้อมูล
              </Button>

              <Button
                sx={{
                  flex: 1,
                  maxWidth: "200px",
                  minHeight: "44px",
                  padding: "10px 12px",
                  borderRadius: 1,
                  color: fontColor(style.secondary_color),
                  background: style.secondary_color,
                  whiteSpace: "normal",
                  lineHeight: 1.4,
                  wordBreak: "keep-all",
                }}
                disabled={!checked || loading || !isFormValid}
                onClick={handleSubmitForReqCa}
              >
                {loading ? (
                  <LoadingComponent width={50} height={50} />
                ) : (
                  "ยืนยันข้อมูล"
                )}
              </Button>
            </div>
          </Card>
        </div>
      </div>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert variant="filled" severity="error" sx={{ width: "100%" }}>
          กรุณากรอกข้อมูลให้ครบถ้วน
        </Alert>
      </Snackbar>

      <CustomModal
        title=""
        centered
        open={modalDuplicateCID}
        onOk={() => setModalDuplicateCID(false)}
        onCancel={() => setModalDuplicateCID(false)}
        footer={null}
        width={335}
      >
        {loading ? (
          <LoadingComponent />
        ) : (
          <Row
            style={{
              paddingTop: "30px",
              paddingBottom: "30px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Col className="d-flex justify-content-center text-center">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <ExclamationCircleOutlined
                  style={{ fontSize: "80px", color: "#ff4d4f" }}
                />
                <br />
                <span>
                  ข้อมูลของท่านเคยลงทะเบียนไว้
                  <br />
                  ในระบบ One ID แล้ว
                  <br />
                  กรุณากด{" "}
                  <a
                    onClick={() => {
                      addBizLogin();
                    }}
                    style={{
                      textDecoration: "underline",
                      color: "#053075",
                      fontWeight: "600",
                    }}
                  >
                    เข้าสู่ระบบด้วย Username และ Password
                    ที่มีการลงทะเบียนด้วยเลขบัตรประชาชน{" "}
                  </a>
                  <br />
                  หรือ{" "}
                  <a
                    onClick={() => {
                      addBizForget();
                    }}
                    style={{
                      textDecoration: "underline",
                      color: "#053075",
                      fontWeight: "600",
                    }}
                  >
                    กดลืมรหัสผ่าน
                  </a>
                </span>
              </div>
            </Col>
          </Row>
        )}
      </CustomModal>
    </div>
  );
}

export default VerifyDetail;
